import { lazy } from "react";
import Loadable from "app/components/Loadable";

const DynamicTableCreate = Loadable(lazy(() => import("./DynamicTableCreate")));

const DynamicTableRoutes = [
  { path: "/assets/dynamic-table", element: <DynamicTableCreate /> },
];

export default DynamicTableRoutes;
